// @ts-nocheck

import type {
  ConsentFormTemplate,
  ConsentType,
  CreateConsentFormsJSON,
  Resident
} from '@lmc/common/types'
import useFeatureFlags from 'hooks/useFeatureFlags'
import React, { type ReactElement } from 'react'
import ConsentFormLegacy from './ConsentFormLegacy'
// Import both versions
import ConsentFormNew from './ConsentFormNew'

type ConsentFormModalProps = {
  fetchResidentConsentForms: (resident: string) => void
  isModalConsentVisible: boolean
  item: string
  category: string
  resident: Resident
  setIsModalConsentVisible: (e: boolean) => void
  templates: ConsentFormTemplate[]
  sendConsentForms: (forms: CreateConsentFormsJSON) => Promise<any>
  closeMainModal: () => void
  consentType: ConsentType
  testId?: string
}

const ConsentFormModalWrapper = (
  props: ConsentFormModalProps
): ReactElement => {
  const featureFlags = useFeatureFlags({ flagNames: ['informed_consent'] }).data
  const isInformedConsentEnabled =
    featureFlags.informed_consent?.enabled || false

  // Return the appropriate version based on feature flag
  if (isInformedConsentEnabled) {
    return <ConsentFormNew {...props} />
  }

  return <ConsentFormLegacy {...props} />
}

export default ConsentFormModalWrapper
